import { render } from "./SettingsDeliveries.vue?vue&type=template&id=66a79e9a"
import script from "./SettingsDeliveries.vue?vue&type=script&lang=js"
export * from "./SettingsDeliveries.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__